import React, {useState,useEffect} from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import Err401 from "../../pages/error/error-401"
import { IsNotNull } from '../../controllers/commons/helper';
const jwt = require("jsonwebtoken");
const { crypter_s,  } = require("../../controllers/encrypt/encrypt");

const AuthCheck = ({ roles, layout: Layout, component: Component, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      const authUser = localStorage.getItem("authUser");
      let currentRole = null;
      let tokenExpired = true;

      if (IsNotNull(authUser)) {
        try {
          const authData = JSON.parse(authUser);
          const token = authData.token;

          if (IsNotNull(token)) {
            // ASYNC AWAIT IS SAFE HERE!
            const decrypted = await crypter_s().decrypt(token);
            const rs_d = jwt.decode(decrypted);

            // Check Expiration
            if (rs_d && rs_d.exp * 1000 > Date.now()) {
              tokenExpired = false;
              currentRole = rs_d.role.split(',');
            }
          }
        } catch (error) {
          console.error("Token validation error:", error);
          // If decryption or parsing fails, token is invalid
        }
      }

      // Cleanup if token is invalid or expired
      if (tokenExpired) {
        localStorage.removeItem("authUser");
        setIsAuthorized(false);
        setUserRole(null);
      } else {
        // Token is valid
        setUserRole(currentRole);
        setIsAuthorized(true);
      }
      
      setLoading(false);
    };

    validateToken();
  }, []); // Run only on mount

  if (loading) {
    // 2. RENDER LOADING STATE WHILE WAITING FOR ASYNC LOGIC
    return <div>Loading...</div>; 
  }

  // 3. HANDLE REDIRECT IF NOT LOGGED IN
  if (!isAuthorized) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: props.location } }}
      />
    );
  }

  // 4. HANDLE ROLE-BASED ACCESS
  const isRoleAuthorized = 
    !roles || roles.length === 0 || // No roles defined means access is granted
    roles.filter(element => userRole && userRole.includes(element)).length > 0;

  if (!isRoleAuthorized) {
    return <Err401 />;
  }

  // 5. RENDER THE COMPONENT AND LAYOUT
  return (
    <Layout>
      <Component {...props} />
    </Layout>
  );
};

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  roles: Roles,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected) {
        return (
          <AuthCheck
            roles={Roles}
            layout={Layout}
            component={Component}
            {...props}
          />
        );
      }
      
      // For un-protected routes, just render the component immediately
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

// const Authmiddleware = ({
//   component: Component,
//   layout: Layout,
//   isAuthProtected,
//   roles: Roles,
//   ...rest
// }) => (
//   <Route
//     {...rest}
//     render={async props => {
//       let role = null
//       if (isAuthProtected && !localStorage.getItem("authUser")) {
//         return (
//           <Redirect
//             to={{ pathname: "/login", state: { from: props.location } }}
//           />
//         )
//       } else {
//         if (IsNotNull(localStorage.getItem("authUser"))) {
//           if (IsNotNull(JSON.parse(localStorage.getItem("authUser")).token)) {
//             let decrypted = await crypter_s().decrypt(JSON.parse(localStorage.getItem("authUser")).token)
//             console.log(decrypted)
//             let rs_d = jwt.decode(decrypted);
//             role = rs_d.role.split(',')
//             if (rs_d.exp * 1000 <= Date.now()) {
//               localStorage.removeItem("authUser")
//             }
//           } else {
//             localStorage.removeItem("authUser")
//             return (
//               <Redirect
//                 to={{ pathname: "/login", state: { from: props.location } }}
//               />
//             )
//           }
//         }
//       }
//       return (
//         <Layout>
//           {
//             Roles !== undefined && Roles.length > 0 ? Roles.filter(element => role.includes(element)).length > 0 ? <Component {...props} /> : <Err401 /> : <Component {...props} />
//           }
//         </Layout>
//       )
//     }}
//   />
// )

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  roles: PropTypes.array
}

export default Authmiddleware
